import { IWithSummaryModel } from '../../../../../common/permission/api/entity/iWithSummary.model';

import { TreatmentFeedbackSummaryModel } from './treatment-feedback.summary.model';
import {TreatmentSummaryModel} from '../../../common/api/model/treatmentSummary.model';

export class TreatmentFeedbackModel implements IWithSummaryModel<TreatmentFeedbackSummaryModel> {
    treatment: TreatmentSummaryModel;
    summary: TreatmentFeedbackSummaryModel;
}

export enum TreatmentFeedbackSatisfaction {

    TREATMENT_FEEDBACK_SATISFACTION_EXCELLENT = 'TREATMENT_FEEDBACK_SATISFACTION_EXCELLENT',
    TREATMENT_FEEDBACK_SATISFACTION_VERY_SATISFIED = 'TREATMENT_FEEDBACK_SATISFACTION_VERY_SATISFIED',
    TREATMENT_FEEDBACK_SATISFACTION_SATISFIED = 'TREATMENT_FEEDBACK_SATISFACTION_SATISFIED',
    TREATMENT_FEEDBACK_SATISFACTION_NOT_SATISFIED = 'TREATMENT_FEEDBACK_SATISFACTION_NOT_SATISFIED',
    TREATMENT_FEEDBACK_SATISFACTION_NOT_SATISFIED_AT_ALL = 'TREATMENT_FEEDBACK_SATISFACTION_NOT_SATISFIED_AT_ALL'

}
